import '../Styles/ProjectsPage.css';
import NavBar from '../Components/ProjectsNavBar'
import Projects from '../Components/Projects';
import React,{useState,useEffect} from "react"
import { getAllProjects } from '../Services/services'
import Loading from '../Components/Loading';

function ProjectsPage(props) {

  const [projects,setProjects] = useState([]);
  const [loading,setLoading] = useState(true);

  useEffect(
    ()=>{
      const request = async ()=>{
          try {
              const response = await getAllProjects()
              console.log(response)
              setProjects(response)
              setLoading(false)
          } catch(e) {
              console.log(e)
              setLoading(false)
          }
      }
      request()
    },[]
  )

  if (loading) {
    return (
      <Loading />
    )
  } else {
    return (
      <div className="ProjectsPage__container">
        <NavBar projects={projects} language={props.language} uk={props.uk} />
        <Projects projects={projects} />
      </div>
    );
  }
}

export default ProjectsPage;